import { useEffect } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { useCart } from "../context/CartContext";

export default function AppLayout({ children }) {
  const { refreshCarts } = useCart();

  useEffect(() => {
    refreshCarts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-screen bg-gray-50" data-testid="app-layout">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        {/* iter 212 (2026-02): overflow-x-clip 代替 overflow-x-hidden。
            hidden 会新建 scroll container 破坏 ProductTable 内的 sticky
            bottom scrollbar;clip 只裁剪不建立滚动祖先,sticky 依然吸附
            视窗底部。仍防止横向溢出污染页面滚动。 */}
        <main className="flex-1 px-6 py-4 overflow-x-clip">{children}</main>
      </div>
    </div>
  );
}
